<template>
  <div class="page-views-chart-wrapper">
    <div class="page-views-chart-nav-wrapper">
      <div 
        class="registrations-heading-wrapper"
      >
        <ar-text
          class="compare-events-text"
          size="md"
          text="Page Views"
        />
      </div>
    </div>

    <div class="page-views-chart-container">
      <div
        class="apex-page-views-chart-wrapper active"
      >
        <am2-apex-area-chart
          class="apex-chart"
          chart-id="registrationsChart"
          :options="chartOptions"
          :series="series"
          :zoom="zoom"
        />
      </div>
    </div>
  </div>    
</template>

<script>
import moment from 'moment'
import { mapState, mapGetters } from 'vuex'
import { mapActions } from 'vuex'
export default {
  name: 'PageViewsChartSection',
  data() {
    return {
      chartOptions: null,
      series: [
        {
          data: [
            [moment("September 19, 2020"), 60],
            [moment("October 2, 2020"), 40],
            [moment("October 20, 2020"), 30],
            [moment("November 5, 2020"), 90],
            [moment("November 13, 2020"), 100],
          ],
          name: "Registrations"
        }

      ],
      zoom: null,
    }
  },
  mounted () {
    this.setCustomChartOptions()
  }, 
  computed: {
    ...mapState({
      eventTicketSales: state => state.event.eventTicketSales,
    }),

    noData() {
      return false;
    },
  },
  methods: {
    ...mapActions({
      setInitialChartData: 'event/SET_INITIAL_TICKET_SALES_CHART_DATA',
      setSalesChartDataLoading: 'event/SET_SALES_CHART_DATA_LOADING'
    }),

    setCustomChartOptions() {
      let options = {
        yaxis: {
          labels: {
            formatter: (val) => {
              return val;
            },
          }
        },
        tooltip: {
          custom: ({series, seriesIndex, dataPointIndex, w}) => {
            let toolTipData = w.config.series[seriesIndex].data[dataPointIndex]
            let dataDate = moment(toolTipData[0][0]).format('MMMM YYYY')

            return `
              <div class="sales-tooltip-wrapper">
                <span class="tooltip-value-wrapper">
                  <span class="tooltip-value">${toolTipData[1]}</span>
                </span>
                <span class="tooltip-date">Registrations</span>
                <span class="tooltip-tab">${dataDate}</span>
              </div>
            `
          }
        },
        noData: {
          text: "No sales data available for this event.",
          align: 'center',
          verticalAlign: 'middle',
          offsetX: 0,
          offsetY: 0,
          style: {
            color: this.$arStyle.color.$blueGrey800,
            fontSize: '14px',
            fontFamily: 'Graphik'
          }
        }
      }

      this.chartOptions = options
    },

    async setInitialTicketData(data) {

      try {
        this.setSalesChartDataLoading(true)
        await this.setInitialChartData([
            [moment("September 19, 2020"), 60],
            [moment("October 2, 2020"), 40],
            [moment("October 20, 2020"), 30],
            [moment("November 5, 2020"), 90],
            [moment("November 13, 2020"), 100],
          ])
      } catch (error) {
        console.log('this.setInitialChartData error:', error)
      } finally {
        this.setSalesChartDataLoading(false)
      }      
    },
  },
}
</script>
<style lang="scss">

$borderColor: $blueGrey500;
$disabledColor: $blueGrey700;

@mixin flexRow {
    display: flex;
    flex-flow: row nowrap;
}

@mixin dropdownOptionsStyle {
  background: white;
  border: 1px solid $borderColor;
  border-radius: 5px; 
  box-shadow: 0px 1px 11px -2px rgba(0, 0, 0, 0.2);
}


.page-views-chart-wrapper {
  grid-column: 1 / span 2;
  background: white;
  border: 1px solid $skyBlueGrey400;
  box-shadow: $blueGrey400 2px 5px 10px;
  border-radius: 4px;
  padding: 30px;

  .page-views-chart-nav-wrapper {
    @include flexRow;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin-bottom: 10px;

    .registrations-heading-wrapper {
      cursor: pointer;
      position: relative;
      outline: none;

    }
  }

  .page-views-chart-container {
    position: relative;

    .page-views-chart-loading-wrapper {
      position: absolute;
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      background: rgba(255, 255, 255, 0.8);
      z-index: 99;
    }

    .apex-page-views-chart-wrapper {
      opacity: 0;
      height: 0px;

      &.active {
        opacity: 1;
        height: 380px;
      }

      .apex-chart {
        height: 100%;
      }
    }
  }  

  .sales-tooltip-wrapper {
    display: flex;
    flex-flow: column nowrap;
    align-items: flex-start;
    justify-content: center;
    width: 180px;
    background: white;
    padding: 12px 15px 18px;
    box-sizing: border-box;
    font-family: 'Graphik';
    font-weight: 400;
    color: $blueGrey800;

    .tooltip-date {
      font-size: 14px;
      margin-bottom: 0;
    }

    .tooltip-tab {
      font-size: 14px;
      color: $blueGrey700;
      margin-top: -5px;
    }

    .tooltip-value-wrapper {
      margin-bottom: 10px;

      .tooltip-value {
        font-size: 24px;
      }

      .tooltip-cents {
        font-size: 14px;
      }
    }        
  }
}
</style>